<template>
  <div class="container-detail">
    <div class="detail-header-buttons">
      <v-btn @click="back" style="width: auto !important" class="button-accept">
        <v-icon>mdi-chevron-left</v-icon>
        Вернуться к списку акционеров
      </v-btn>

      <v-btn @click="goToEdit" style="width: auto !important" class="button-action">
        Редактировать
      </v-btn>
    </div>

    <div class="detail-main">
      <div class="detail-main-first-container" v-if="item">
        <div class="first-container-box">
          <div class="container-box-title">ФИО</div>
          <div class="container-box-text">
            {{ item.fullName }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Должность </div>
          <div class="container-box-text">
            {{ item.position }}
          </div>
        </div>
        <div class="first-container-box">
          <div class="container-box-title">Электронная почта </div>
          <div class="container-box-text" v-for="(i, ind) in item.emails" :key="ind">
            {{ i }}
          </div>
        </div>

      </div>
      <div class="detail-main-second-container">
        <div class="second-container-box">
          <div class="container-box-title">Фото сотрудника</div>
          <div class="container-box-text">
            Нажмите на изображение, чтобы увидеть его в полном размере
          </div>
        </div>

        <div>
          <v-simple-table v-if="item">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Формат</th>
                  <th class="text-left">Место отображенния</th>
                  <th class="text-left">Для смартфонов</th>
                  <th class="text-left">Для планшетов</th>
                </tr>
              </thead>
              <tbody>
                <tr style="height: 60px">
                  <td class="text-left">Фото сотрудника</td>
                  <td class="text-left">
                    Основное фото сотрудника
                  </td>
                  <td class="text-left">
                    <img @click="openDialogImg(item.smartphoneImage)" v-if="item.smartphoneImage" class="table-img"
                      :src="item.smartphoneImage" />
                  </td>
                  <td class="text-left">
                    <img @click="openDialogImg(item.tabletImage)" v-if="item.tabletImage" class="table-img"
                      :src="item.tabletImage" />
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <DialogImage v-model="dialogImg" :src="previewImage" />
          <v-divider></v-divider>
        </div>

        <div class="second-container-box" style="margin-top: 32px" v-if="item && item.isHidden">
          <div class="container-box-title">Параметры публикации и отображения</div>
        </div>
        <div>
          <div v-if="item && item.isHidden">
            Скрыть из списка обращений (сотрудник не будет отображаться)
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data: () => ({
    item: null,
    dialogImg: false,
    previewImage: null,
    hideNews: false,
    imageWidth: 0,
  }),
  methods: {
    openDialogImg(src) {
      this.previewImage = src;
      this.dialogImg = true;
    },
    back() {
      this.$router.push({ name: "Appeal" });
    },
    goToEdit() {
      this.$router.push({
        name: "AppealUserEdit",
        params: { id: this.$route.params.id },
      });
    },
    getItem() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV5 +
            "/appeal/employee/" +
            this.$route.params.id,
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
              "secret-key": this.$store.state.secretKeyCookie,
            },
          }
        )
        .then((res) => {
          this.item = res.data;
        })
        .catch((err) => {
          this.$store.commit('errorSet', true)
          this.$store.commit('errorTextSet', err)
        });
    },
  },
  created() {
    this.getItem();
  },
};
</script>
<style lang="scss" scoped>
.container-detail {
  box-sizing: border-box;
  padding: 40px !important;

  .detail-header-buttons {
    display: flex;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  .detail-main {
    display: flex;
    justify-content: space-between;

    .detail-main-first-container {
      width: 48%;

      .first-container-box {
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }

        .container-box-text-list {
          .container-box-text-list-item {
            display: flex;
            margin-bottom: 5px;

            .list-item-subtitle {
              font-size: 16px;
              font-weight: 600;
              color: #929292;
              width: 200px;
            }

            .list-item-text {
              font-size: 18px;
              font-weight: 400;
            }
          }
        }
      }
    }

    .detail-main-second-container {
      width: 48%;

      .table-img {
        cursor: pointer;
        height: 38px;
        object-fit: contain;
      }

      .second-container-box {
        width: 100%;
        margin-bottom: 40px;

        .container-box-title {
          font-size: 24px;
          font-weight: 600;
        }

        .container-box-text {
          font-size: 18px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>